<template>
  <g>
    <path
      :d="path"
      fill="none"
      class="stroke-mid-neutral-200"
      stroke-width="2"
    />
  </g>
</template>

<script setup lang="ts">
import type { EdgeProps } from "@vue-flow/core";
import { computed, defineProps } from "vue";

const { data } = defineProps<
  EdgeProps<{
    sections: {
      startPoint: { x: number; y: number };
      endPoint: { x: number; y: number };
      bendPoints?: { x: number; y: number }[];
    }[];
  }>
>();
const path = computed(() => {
  if (!data.sections || data.sections.length === 0) return "";

  return data.sections
    .map((section) => {
      const points = section.startPoint
        ? [section.startPoint, ...(section.bendPoints || []), section.endPoint]
        : [];

      return points
        .map((point, index) => {
          const command = index === 0 ? "M" : "L";
          return `${command} ${point.x} ${point.y}`;
        })
        .join(" ");
    })
    .join(" ");
});
</script>
